// LoadingSpinner.js
import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="spinner">
      {/* You can customize this spinner as needed */}
      <div className="loading" />
    </div>
  );
};

export default LoadingSpinner;
